import { styled, Box } from "@mui/material";

const Row = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  gap: "3rem",
});

export default Row;
